import { useEffect } from 'react';

/**
 * Hook to handle browser back/forward navigation (popstate events).
 * Useful for resetting state when the user navigates using browser controls,
 * especially when window.history.replaceState bypasses React Router.
 *
 * @param callback - Function to call when back/forward is triggered
 */
export const usePopState = (callback: () => void) => {
  useEffect(() => {
    window.addEventListener('popstate', callback);
    return () => {
      window.removeEventListener('popstate', callback);
    };
  }, [callback]);
};
